import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AgGridModule } from 'ag-grid-angular';
import { ColDef, GridApi, ModuleRegistry, AllCommunityModule } from 'ag-grid-community';
import { NgFor, NgIf } from '@angular/common';
import { environment } from '../../../../environments/environment';

ModuleRegistry.registerModules([AllCommunityModule]);

@Component({
  selector: 'glo-grid',
  imports: [AgGridModule, NgFor, NgIf],
  templateUrl: './grid.component.html',
  styleUrls: ['./grid.component.scss']
})
export class GloGridComponent {
  @Input() rowData: any[] = [];
  @Input() colDefs: ColDef[] = [];
  @Input() pageSize: number = 10;
  @Input() rowSelection: string = 'multiple'

  @Output() onRowSelection = new EventEmitter<any>()
  @Output() gridReady = new EventEmitter<any>()

  assetUrl = environment.assetBaseUrl

  gridApi!: GridApi;
  currentPage: number = 0;
  totalPages: number = 0;
  pages: number[] = [];

  onGridReady(params: any) {
    this.gridApi = params.api;
    this.updatePagination();
    this.gridReady.emit(params.api)
  }

  onRowSelected(params: any) {
    // Only emit when the row is SELECTED, not unselected
    if (params.node.__selected) {
      this.onRowSelection.emit(params.data);
    }
  }

  updatePagination() {
    if (!this.gridApi) return;
    const rowCount = this.gridApi.paginationGetRowCount();
    const pageSize = this.gridApi.paginationGetPageSize();
    this.totalPages = Math.ceil(rowCount / pageSize);
    this.pages = Array.from({ length: this.totalPages }, (_, i) => i + 1);
  }

  goToPage(pageIndex: number) {
    if (!this.gridApi) return;
    this.gridApi.paginationGoToPage(pageIndex);
    this.currentPage = pageIndex;
  }

  onPrevious() {
    if (this.currentPage > 0) {
      this.goToPage(this.currentPage - 1);
    }
  }

  onNext() {
    if (this.currentPage < this.totalPages - 1) {
      this.goToPage(this.currentPage + 1);
    }
  }
}
